import React from 'react';
import { NamedLink } from '../../../components';
import Slider from 'react-slick';
import classNames from 'classnames';

import css from './Sections.module.css';
import '../../../styles/slick/slick.css';
import '../../../styles/slick/slick-theme.css';
import { ensureUser } from '../../../util/data';
import Icons from '../../../components/Icons/Icons';

function SectionBlog(props) {
  const { sliderSettings, listings, intl, viewport, currentUser } = props;

  const title = intl.formatMessage({ id: 'SectionTestimonial.title' });

  const isMobileLayout = viewport && viewport.width > 0 && viewport.width < 768;

  return (
    <div className={css.sectionBlog}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            <h2>From Our Blog</h2>
          </div>
        </div>
        <div className={css.featuredListingsContent}>
          <Slider {...sliderSettings}>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialImg}>
                <img
                  src="https://www.soulsearch.io/uploads/news-pictures/5851-sacramento-blog-post-image-20241104192609.png"
                  alt=""
                />
              </div>
              <div className={css.testimonialDescription}>
                <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                <h4>How Positive Thinking Leads to Happiness, Gratitude, and Joy</h4>
                <p>
                  When life gives me lemons, I make lemonade. If there’s water in my cup, I see it
                  as half full. That’s the way I’ve come to be, an optimist looking at the bright
                  side of life. Over the years I have come to understand that I have a choice, I can
                  find joy in the little things in life or indulge in entertaining negativity. We’re
                  all guilty of allowing things that are outside of ourselves to affect our mood,
                  it’s human!
                </p>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                    <p>Edmonton, Canada</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialImg}>
                <img
                  src="https://www.soulsearch.io/uploads/news-pictures/5789-fairfax-blog-post-image-20241029125301.jpg"
                  alt=""
                />
              </div>
              <div className={css.testimonialDescription}>
                <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                <h4>
                  The Emperor’s New Clothes, Trump & the Democrats: A time for critical thinking
                </h4>
                <p>
                  Critical thinking is based on a desire for truth and clarity, and a commitment to
                  look beyond our fears, biases and blind spots. If you value critical thinking, I
                  request that you read this article with an open mind. See what it evokes in you.
                  If you have some opinions that differ from mine and you read it anyway, that will
                  be a heroic act, so thank you in advance!
                </p>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                    <p>Edmonton, Canada</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialImg}>
                <img
                  src="https://www.soulsearch.io/uploads/news-pictures/5789-fairfax-blog-post-image-20240920173158.jpg"
                  alt=""
                />
              </div>
              <div className={css.testimonialDescription}>
                <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                <h4>Holding Complexity: US Presidential Election & the 4th Dimension</h4>
                <p>
                  Some words used to describe this year’s US Presidential election are “bizarre”, “a
                  critical choice”, “crazy”, or as Vice Presidential candidate Tim Walz put it,
                  “weird”. Have you ever wondered WHY it seems so wierd? This article offers a way
                  to understand what we’re going through as a transit through dimensional states of
                  consciousness.
                </p>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                    <p>Edmonton, Canada</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={css.testimonialBlock}>
              <div className={css.testimonialImg}>
                <img
                  src="https://www.soulsearch.io/uploads/news-pictures/5251-menlo-park-blog-post-image-20240807221932.jpg"
                  alt=""
                />
              </div>
              <div className={css.testimonialDescription}>
                <NamedLink name="LandingPage">The Power of Positive Thinking</NamedLink>
                <h4>Lion's Gate Activation</h4>
                <p>
                  As Earth, Sirius, and Orion move into alignment, at this time of the Lion's Gate
                  Portal that peaks on 8/8, may you activate your soul alignment with all that you
                  desire in this next unfolding chapter of your life. Like the lion, you are called
                  to be regal, to set your standards high and own the evolutionary leadership you
                  are here to bring in on this planet. And as a star-being, may you feel the Earth
                  and stars lining up to support you magically at this potent time. Whatever you
                  most desire, I invite you to spend some time reflecting on it and setting a clear
                  intention for this Lion's Gate Portal.
                </p>
              </div>
              <div className={css.userInfo}>
                <div className={css.userLeft}>
                  <div className={css.authorDetails}>
                    <h3>John Smith</h3>
                    <p>Personal trainer, FitLife Gym</p>
                    <p>Edmonton, Canada</p>
                  </div>
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
}

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: false,
  autoplaySpeed: 3000,
  autoplay: false,
  speed: 500,
  slidesToShow: 3, // Display 4 items on desktop
  slidesToScroll: 1, // Scroll 1 item at a time
  variableWidth: false,
  focusOnSelect: false,
  centerMode: false,
  responsive: [
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 1280,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 990,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 676,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};
SectionBlog.defaultProps = {
  sliderSettings,
};

export default SectionBlog;
